import React from 'react';

function Quote() {
  return (
    <div className="home-content ">
      <p>
        Mathematics is not about numbers,equations,computation or algorithms:
        its about understanding. William Paul Thurston
      </p>
    </div>
  );
}

export default Quote;
